import '../css/find-a-dentist.scss';
import {render as renderReact} from 'preact/compat';
import FindADentist from '@containers/FindADentistOptIn';
import {client} from '@modules/core/GraphQLProvider';
import {UpdateOptInProductOfferings} from '@services/Customer/query.graphql';
import {delegateToDataAttribute} from '@util/EventUtils';

document.addEventListener( 'DOMContentLoaded', () => {
    let hasAcceptedTerms = false;
    const root = document.getElementById( 'FaDRegistration-root' );
    if ( root ) {
        renderReact( <FindADentist/>, root );
    }

    async function acceptFADTerms () {
        return client.mutate( {
            mutation: UpdateOptInProductOfferings,
            variables: {input: true}
        } );
    }

    var acceptTermsHandler = delegateToDataAttribute( 'acceptfadproductofferingterms', ( e ) => {
        if ( hasAcceptedTerms ) {
            return;
        }
        hasAcceptedTerms = true;
        e.target.disabled = true;
        e.target.parentElement.innerHTML =
            '<p class="subheading-base my-4">Thank you for accepting. You will be redirected where you can manage your product offerings shortly...</p>';
        acceptFADTerms().then( () => {
            window.location.reload();
        } )
    } );

    document.addEventListener( 'click', acceptTermsHandler );
} )

